import WidgetPlaceholderContainer from './WidgetPlaceholderContainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import WidgetIcon from 'ContentComponents/components/cmv2/WidgetIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BaseWidgetPlaceholder = ({
  moduleSpec,
  label,
  overrideIcon,
  children
}) => {
  return /*#__PURE__*/_jsx(WidgetPlaceholderContainer, {
    children: /*#__PURE__*/_jsxs(TFlex, {
      alignItems: "center",
      flexDirection: "column",
      gap: 8,
      textAlign: "center",
      children: [overrideIcon ? /*#__PURE__*/_jsx(IconHolder, {
        icon: overrideIcon,
        size: "850",
        padding: "0"
      }) : /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(WidgetIcon, {
          icon: moduleSpec.icon,
          alignment: "middle",
          size: 34
        })
      }), /*#__PURE__*/_jsx("span", {
        children: label
      }), children]
    })
  });
};
export default BaseWidgetPlaceholder;